import ApiClient from '../ApiClient';

class WgptEventAutomationsAPI extends ApiClient {
  constructor() {
    super('event_automations', { accountScoped: true, wgpt: true });
  }
}

export default new WgptEventAutomationsAPI();
